export default __webpack_public_path__ + "src/images/packages/bakubung-villas/238295b6043bdc3b661ac9c37cf0052e-2.jpg";